const apiUrl = process.env.REACT_APP_API_URL;
export const PutRebutGrup = async ( json: string , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/rebuts`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
